import React, {useEffect, useState} from 'react';
// import Axios from 'axios'; // ToDo: ZK - I will use later
import {connect} from "react-redux";
import axios from 'axios';

import PanelNavigation from './components/PanelNavigation';
import NavigationContainers from './components/NavigationContainers';
import LogicEditorHeader from './components/LogicEditorHeader';
import Graph from './components/Graph';
import NodePanel from "../../../NodeEditorPanel/panels/NodePanel";
import LogicTestingPanel from "./components/LogicTestingPanel/";

import {showToastForBackend,showToastForFrontend} from "../../../../actions/toastActions";
import getAxiosConfig from '../../../../utils/axiosConfig';
import TopMenu from "../../../TopMenu";
import {setContextProperties} from "../../../../actions/contextPropertiesActions";
import {setSettingsToRetrieve} from "../../../../actions/settingsToRetrieveActions";
import {Helmet} from "react-helmet";
import messageCodes from "../../../../utils/messageCodes";
import {Navigate, useNavigate, useParams} from "react-router-dom";
import {setContextUpdaters} from "../../../../actions/contextUpdaterActions";
import {setContextPropertiesToRetrieve} from "../../../../actions/contextPropertiesToRetrieveActions";
import {setAttributesToRetrieve} from "../../../../actions/attributesToRetrieveActions";
import onGoLiveRequest from "../../../../common/onGoLiveRequest";

const INIT_GRAPH_DATA = {
  tabData: {
    newNodes: true,
    finder: false,
    version: false,
    usages: false,
    context: false,
    variables: false,
    show: true,
    versionHistory: false
  },
  nodeData: {
    date: '',
    title: '',
    type: '',
    bgColor: ''
  },
  logicName: '',
  graphData: '',
  logicVersionsData: [],
  initialGraph: {
    "data": {
      "contextProps": [
        {
          "name": "itemId",
          "publicName": "Item ID",
          "description": "Item ID etc.",
          "addedByUpdater": false
        }
      ]
    },
    "edges": [
      {
        "id": 4,
        "fromPort": {
          "id": 7,
          "node": 7
        },
        "toPort": {
          "id": 8,
          "node": 8
        }
      }
    ],
    "nodes": [
      {
        "component": null,
        "id": 7,
        "inLogicId": "0",
        "name": "All Items",
        "options": {
          "viewData": {
            "x": 140,
            "y": 235
          },
          "maxResults": 500
        },
        "ports": [{
          "id": 7,
          "input": false,
          "label": null,
          "node": 7,
          "portIndex": 0
        }],
        "sectionType": "first-blocks",
        "title": "All Items",
        "type": "all_items"
      },
      {
        "component": null,
        "id": 8,
        "inLogicId": "1",
        "name": "Output",
        "options": {
          "viewData": {
            "x": 700,
            "y": 235
          },
          "logDecisionName": null,
          "settings": null,
          "totalItemCount": 20,
        },
        "ports": [
          {
            "id": 8,
            "input": true,
            "label": null,
            "node": 8,
            "portIndex": 0
          }
        ],
        "sectionType": "touchpoint",
        "title": "Output",
        "type": "basic_output"
      }
    ]
  },
  componentData: {
    saveLogic: 0,
    testLogic: 0,
    cloneSelected: 0,
    copySelected: 0,
    pasteSelected: 0,
    arrangeLogic: 0,
    removeSelected: 0,
    removeUnconnectedEdges: 0,
    clearAll: 0,
    cloneLogic: 0
  },
  showLogicTestModal: false
}

const SLASH = "/"

const Detail = ({
  privileges,
  properties,
  modal,
  showToastForBackend,
  showToastForFrontend,
  setContextProperties,
  setContextUpdaters,
  setAttributesToRetrieve,
  setContextPropertiesToRetrieve,
  setSettingsToRetrieve,
}) => {
  const {logicId, versionNumber} = useParams();
  const navigate = useNavigate();
  const [detailData, setDetailData] = useState(INIT_GRAPH_DATA);
  const [latestLogicVersion, setLatestLogicVersion] = useState(versionNumber);
  const [isUpdatableLogic, setIsUpdatableLogic] = useState(true);

  useEffect(() => {
    const versionInfoUrl = `${properties.logicUrl}/${logicId}/versions`;
    axios.get(versionInfoUrl,
        getAxiosConfig()).then((result) => {
      if (result) {
        const sortedResultData = result.data.sort(
            (first, second) => second.version - first.version)
        setLatestLogicVersion(sortedResultData[0].version)
        setDetailData(prevState => ({
          ...prevState,
          logicVersionsData: sortedResultData,
        }));
      }
    }).catch((err) => {
      if (err.response) {
        showToastForBackend(err.response.data);
      }
    });
  }, [properties.logicUrl, logicId, detailData.graphData.version]);

  const redirectToVersionUrl = (version) => {
    if (!version) {
      const versionInfoUrl = `${properties.logicUrl}/${logicId}/versions`;
      axios.get(versionInfoUrl,
          getAxiosConfig()).then((result) => {
        if (result) {
          const sortedResultData = result.data.sort(
              (first, second) => second.version - first.version)
          const latestVersion = sortedResultData[0].version
          navigate(`/logics/${logicId}/versions/${latestVersion}`)
        }
      }).catch((err) => {
        if (err.response) {
          showToastForBackend(err.response.data);
        }
      });
    } else {
      navigate(`/logics/${logicId}/versions/${version}`)
    }
  }

  const changeLocation = (version) => {
    const currentUrl = window.location.href.split(SLASH);
    currentUrl.pop();
    const newUrl = currentUrl.join(SLASH) + SLASH + version
    window.history.replaceState(null, "Detail Title", newUrl)
  }

  useEffect(() => {
    if (!versionNumber) {
      redirectToVersionUrl(latestLogicVersion)
    } else {

      const logicVersionDataUrl = `${properties.logicUrl}/${logicId}/${versionNumber}`;

      axios.get(logicVersionDataUrl, getAxiosConfig()).then((result) => {
        if (result) {
          setDetailData(prevState => ({
            ...prevState,
            graphData: result.data,
            logicName: result.data.logic.name
          }));
          const data = result.data.data;
          setContextProperties(data?.contextProps || []);
          setContextUpdaters(data?.contextUpdaters || []);
          setAttributesToRetrieve(data?.attributesToRetrieve || []);
          setContextPropertiesToRetrieve(data?.contextPropertiesToRetrieve || []);
          setSettingsToRetrieve(data?.settingsToRetrieve || []);
          const isLastVersion = versionNumber.toString()
              === latestLogicVersion.toString()
          setIsUpdatableLogic(isLastVersion)
        }
      }).catch((err) => {
        if (err.response) {
          showToastForBackend(err.response.data);
        }
      });
    }
  }, [properties.logicUrl, logicId, versionNumber]);

  const selectedMenu = (value) => {
    let tabData = {
      newNodes: false,
      finder: false,
      version: false,
      usages: false,
      context: false,
      variables: false,
      show: false,
      versionHistory: false
    };
    let onStateTabData = detailData.tabData;
    if (!onStateTabData[value]) {
      tabData[value] = true;
      tabData.show = true;
    }
    setDetailData(prevState => ({
      ...prevState,
      tabData: tabData
    }));
  };

  const drag = (event, title, type, sectionType) => {
    event.dataTransfer.setData('title', title);
    event.dataTransfer.setData('type', type);
    event.dataTransfer.setData('sectionType', sectionType);
  };
  const clickNode = (title, type, sectionType) => {
    setDetailData(prevState => ({
      ...prevState,
      nodeData: {
        date: new Date(),
        title: title,
        type: type,
        sectionType: sectionType
      }
    }));
  };
  const updateGraph = (value) => {
    setDetailData(prevState => ({
      ...prevState,
      componentData: {
        ...prevState.componentData,
        [value]: prevState.componentData[value] + 1
      }
    }));
  };

  const updateGraphData = (value) => {
    setDetailData(prevState => ({
      ...prevState,
      graphData: {...value}
    }));
    changeLocation(value.version)
    setIsUpdatableLogic(true)
  };

  const toggleLogicTestModal = () => {
    setDetailData(prevState => ({
      ...prevState,
      showLogicTestModal: !prevState.showLogicTestModal
    }));
  };

  const changeLogicName = (value) => {
    setDetailData(prevState => ({
      ...prevState,
      logicName: value
    }));
  };

  const setNodesCopied = (copied) => {
    setDetailData(prevState => ({
      ...prevState,
      nodesCopied: copied
    }));
  };

  const rerenderGraph = () => {
    setDetailData(prevState => ({
      ...prevState,
      graphData: {
        ...detailData.graphData
      }
    }));
  }

  const renameLogic = () => {
    const renameLogicUrl = `${properties.logicUrl}/rename`;
    axios.post(renameLogicUrl,
        {
          "logicId": detailData.graphData.logic.id,
          "newLogicName": detailData.logicName,
        },
        getAxiosConfig()
    ).then((result) => {
      const graphData = {...graphData.graphData};
      graphData.logic.name = graphData.logicName;
      setDetailData(prevState => ({
        ...prevState,
        graphData: graphData
      }));
      showToastForFrontend(messageCodes.RENAME_SUCCESS);
    }).catch((err) => {
      if (err.response) {
        showToastForBackend(err.response.data);
      }
    });
  };

  const hasNotAccess = () => {
      return privileges['Logics Detail'] === "no access";
    }

  const isReadOnly = () => {
      return privileges['Logics Detail'] === "read-only";
  }

  const handleOnGoLive = () => {
    const toGoLiveLogic = [logicId];

    onGoLiveRequest(
        properties.logicUrl,
        showToastForFrontend,
        showToastForBackend,
        toGoLiveLogic
    )
  }

  return (
      <>
          {hasNotAccess() && (
              <Navigate to="/"/>
          )}
          <div className="logic-editor">
            <Helmet>
              <title>{detailData.graphData.logic ? (detailData.graphData.logic.name
                  + " | Logic") : "Logic"}</title>
            </Helmet>
            <TopMenu logicData={detailData.graphData}/>
            <LogicEditorHeader
                logicName={detailData.logicName}
                updateGraph={(value) => updateGraph(value)}
                type={detailData.graphData.logic ? detailData.graphData.logic.type
                    : "MASTER"}
                changeLogicName={changeLogicName}
                renameLogic={renameLogic}
                buttonsDisabled={!isUpdatableLogic}
                isReadOnly={isReadOnly()}
                onGoLive={handleOnGoLive}
            />
            <div className="panel-wrapper">
              <PanelNavigation selectedMenu={(value) => selectedMenu(value)}
                               isReadOnly={isReadOnly()}
                               tabData={detailData.tabData}/>
              <div className="graph-panel-container">
                {!isReadOnly()  && (
                    <NavigationContainers clickNode={clickNode}
                                          dragProps={drag}
                                          tabData={detailData.tabData}
                                          logicVersions={detailData.logicVersionsData}
                                          logicId={logicId}
                    />
                )}
                <div className="graph-editor">
                  {detailData.graphData !== '' && (
                      <Graph
                          graphData={detailData.graphData}
                          initialGraph={detailData.initialGraph}
                          saveLogic={detailData.componentData.saveLogic}
                          testLogic={detailData.componentData.testLogic}
                          cloneLogic={detailData.componentData.cloneLogic}
                          nodeData={detailData.nodeData}
                          copySelected={detailData.componentData.copySelected}
                          pasteSelected={detailData.componentData.pasteSelected}
                          cloneSelected={detailData.componentData.cloneSelected}
                          arrangeLogic={detailData.componentData.arrangeLogic}
                          removeSelected={detailData.componentData.removeSelected}
                          removeUnconnectedEdges={detailData.componentData.removeUnconnectedEdges}
                          clearAll={detailData.componentData.clearAll}
                          toggleLogicTestModal={toggleLogicTestModal}
                          updateGraphData={updateGraphData}
                          setNodesCopied={setNodesCopied}
                          logicId={logicId}
                      />
                  )}
                  {modal && <NodePanel/>}
                  {detailData.showLogicTestModal && (
                      <LogicTestingPanel toggleLogicTestModal={toggleLogicTestModal}
                                         graph={detailData.graphData}
                                         onDebugRecomendationsGot={rerenderGraph}
                                         onDebugDisabled={rerenderGraph}
                      />
                  )}
                </div>
              </div>
            </div>
          </div>
      </>
  );
}

const mapStateToProps = (state) => {
  return {
    properties: state.properties,
    modal: state.modalInfo.modal,
    node: state.modalInfo.node,
    contextProperties: state.contextProperties,
    attributesToRetrieve: state.attributesToRetrieve,
    contextPropertiesToRetrieve: state.contextPropertiesToRetrieve,
    settingsToRetrieve: state.settingsToRetrieve,
    copyNodes: state.copyNodes
  };
}

export default connect(mapStateToProps, {
  showToastForBackend,
  showToastForFrontend,
  setContextProperties,
  setContextUpdaters,
  setAttributesToRetrieve,
  setContextPropertiesToRetrieve,
  setSettingsToRetrieve,
})(Detail);
